module.exports = __webpack_public_path__ + "img/symbol_10_x3.0891c53b.png";